import jsPDF from "jspdf";
import "jspdf-autotable";

export function generatePdf(
  genSettings,
  record,
  StartDate,
  EndDate,
  tableData
) {
  // const shopName = this.storeName;
  var doc = new jsPDF({ compress: true });
  var totalPagesExp = "{total_pages_count_string}";
  // var pageHeight =
  //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
  var pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.text("Stock Transfer Delivery", pageWidth / 2, 10, "center");
  doc.line(5, 11, pageWidth - 5, 11); // Top Line
  doc.setFontSize(10);

  //   doc.text("Original", pageWidth - 20, 14);

  doc.setFontSize(10);

  /*
  -------------------------------------------------------------------------------
                BEGINNING OF CUSTOMER DETAILS AND DOCUMENT DETAILS
   -----------------------------------------------------------------------------
  */

  /**
   * Customer Details
   */
  doc.addFont("Tahoma");
  doc.setFont("Tahoma", "bold");
  doc.setFontSize(16);

  doc.setFontSize(11);

  var img = new Image();

  var tableStartingPoint = null;

  // console.log(genSettings.headerImg, '');

  if (genSettings.headerImg) {
    img.src = genSettings.headerImg;
    doc.addImage(img, "png", 10, 15, pageWidth - 20, 50);

    doc.text("Doc No: " + record.DocNum, 10, 75);
    doc.text("To: " + record.ocrd.Name, 10, 80);

    tableStartingPoint = 85;
  }

  if (!genSettings.headerImg) {
    // check if logo exist
    if (genSettings.logo) {
      img.src = "data:image/jpeg;base64," + genSettings.logo;
      doc.addImage(img, "jpg", 10, 15, 60, 30);

      if (genSettings.PhysicalAddress) {
        doc.text(genSettings.PhysicalAddress, pageWidth - 10, 20, "right");
      }

      if (genSettings.poBox) {
        doc.text(genSettings.poBox, pageWidth - 10, 25, "right");
      }

      if (genSettings.PhoneOne) {
        doc.text(
          "Tel: " + genSettings.PhoneOne + " / " + genSettings.PhoneTwo,
          pageWidth - 10,
          30,
          "right"
        );
      }

      if (genSettings.CompanyEmail) {
        doc.text(
          "Email: " + genSettings.CompanyEmail,
          pageWidth - 10,
          35,
          "right"
        );
      }

      if (genSettings.PinNo) {
        doc.text("VAT No: " + genSettings.PinNo, pageWidth - 10, 40, "right");
      }

      doc.text("Date: " + record.DocDate, pageWidth - 10, 47, "right");

      doc.line(5, 50, pageWidth - 5, 50); // Top Line

      doc.text("Delivery No: " + record.DocNum, 10, 55);
      doc.text("From: " + record.fromstore.Name, 10, 60);
      doc.text("To: " + record.tostore.Name, pageWidth - 10, 55, "right");
      doc.text("Picked By: " + record.pickedby.name, pageWidth -  10, 60, "right");

      doc.text(
        "Goods received in good order and condition",
        pageWidth / 2,
        65,
        "center"
      );


      tableStartingPoint = 70;
    }

    // check if logo does not exist

    if (!genSettings.logo) {
      if (genSettings.CompanyName) {
        doc.text(genSettings.CompanyName, 10, 20);
      }

      doc.setFontSize(11);
      if (genSettings.CompanyEmail) {
        doc.text(genSettings.CompanyEmail, 10, 25);
      }

      if (genSettings.PhysicalAddress) {
        doc.text(genSettings.PhysicalAddress, 10, 30);
      }

      if (genSettings.PinNo) {
        doc.text("P.O BOX : " + genSettings.poBox, pageWidth - 10, 20, "right");
      }

      if (genSettings.PhoneOne) {
        doc.text(
          "Cell: " + genSettings.PhoneOne + " / " + genSettings.PhoneTwo,
          pageWidth - 10,
          25,
          "right"
        );
      }

      if (genSettings.PinNo) {
        doc.text("VAT No: " + genSettings.PinNo, pageWidth - 10, 30, "right");
      }

      doc.line(5, 33, pageWidth - 5, 33); // Top Line

      doc.setFontSize(11);

      doc.text("Date: " + record.DocDate, pageWidth - 50, 40);

      doc.text("Delivery No: " + record.DocNum, 10, 45);

      doc.text("Please receive the following in good order and condition", 60, 55);

      tableStartingPoint = 60;
    }
  }

  function headRowsRefDetails() {
    return [
      {
        count: "",
        name: "",
        Date: "",
        createDate: "",
        Received: "",
        Line: "",
      },
    ];
  }

  // Columns
  function headRowsItemDetails() {
    return [
      {
        count: "",
        itemCode: "ITEM CODE",
        description: "PRODUCT",
        Quantity: "QUANTITY",
      },
    ];
  }

  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.setFont("Georgia, serif");

  const itemDetails = [];
  for (const note of tableData) {
    const i = tableData.indexOf(note);
    const itemDetail = {
      count: i + 1,
      itemCode: note.product.ItemCode,
      description: note.product.Name,
      Quantity: note.Quantity.toLocaleString(),
    };

    itemDetails.push(itemDetail);
  }

  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.setFont("Georgia, serif");
  doc.autoTable({
    head: headRowsItemDetails(),
    body: itemDetails,
    theme: "grid",
    headStyles: { fillColor: "#808080" },
    bodyStyles: {
      textColor: "#000000",
      fontSize: 11,
    },
    tableWidth: pageWidth - 10,
    columnStyles: {
      total_amount: {
        halign: "left",
        fontStyle: "bold",
      },
      Price: {
        fontStyle: "bold",
      },
      styles: {
        font: "Tahoma",
        fontSize: 11,
      },
    },

    margin: { left: 5 },
    didDrawPage: function(data) {
      // Footer
      var str = "Page";
      var pageCount = doc.internal.getNumberOfPages();
      let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
      if (typeof doc.putTotalPages === "function") {
        str = "Page " + pageCurrent + " of " + pageCount;
      }
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize;
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(str, data.settings.margin.right, pageHeight - 10);
    },

    startY: tableStartingPoint,
  });

 // var pageSize = doc.internal.pageSize;
  //var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();



  // doc.text(
  //   "Goods received in good order and condition",
  //   pageWidth / 2,
  //   pageHeight - 40,
  //   "center"
  // );

  // doc.text(
  //   "Received by: __________________________________   Sign: ________________________________",
  //   pageWidth / 2,
  //   pageHeight - 25,
  //   "center"
  // );

  // Total page number plugin only available in jspdf v1.0+
  if (typeof doc.putTotalPages === "function") {
    doc.putTotalPages(totalPagesExp);
  }

  const secondDocRemark = [];

    const row3DocRemark = {
      count: "Received By: ",
      name: "___________________________",
      Date: "Date: ",
      createDate: "_____________________",
      Received: "Sign: ",
      Line: "________________",
    };
    secondDocRemark.push(row3DocRemark);
  

  doc.autoTable({
    head: headRowsRefDetails(),
    body: secondDocRemark,
    theme: "plain",

    columnStyles: {
      count: {
        fontStyle: "bold",
        font: "Tahoma",
      },
      Date: {
        fontStyle: "bold",
        font: "Tahoma",
      },
      Received: {
        fontStyle: "bold",
        font: "Tahoma",
      },

      bodyStyles: { minCellHeight: 40 },
    },
    bodyStyles: {
      textColor: "#000000",
      fontSize: 10,
    },
    startY: doc.autoTable.previous.finalY + 5,
    styles: {
      overflow: "hidden",
      fontSize: 11,
    },
    margin: { left: 10 },
    didDrawPage: function (data) {
      // Footer
      var str = "Page " + doc.internal.getNumberOfPages();
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        str = str + " of " + totalPagesExp;
      }

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize;
      var pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      doc.text(str, data.settings.margin.right, pageHeight - 10);

      doc.setFontSize(10);


    },
  });


  return doc.output("bloburi");
}
